<template>
  <!--回顶-->
  <!-- immediate=true 让 van-back-top 用 behavior:'auto' 瞬间跳回顶部，而非默认的 smooth 平滑滚动：
       平滑滚动会“扫过”整个长列表，途中每一帧都要重绘经过的卡片（配合 content-visibility 还会反复重排），
       在微信/低端 WebView 上赔不起帧预算，就会卡顿甚至短暂白屏；瞬间跳转只需绘制顶部一屏 -->
  <van-back-top v-if="isShowBackTop" :immediate="isImmediateBackTop" :offset="backTopOption.offset" :bottom="backTopOption.bottom" class="back-top" :class="{ 'page-scroll': isPageScroll }">
    <GlobalImage class="back-top--icon" :src="getImageUrl('public', 'back-top.png')" />
  </van-back-top>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, onBeforeUnmount, ref } from 'vue'
import { getImageUrl } from '@/utils'
import { store } from "@/pinia/store"

const storeData = store()
const currentPosition = ref(0)
const scrollTimer = ref()
const pageRatio = (document.body.clientWidth / 375) || 1
const backTopOption = reactive({
  offset: document.body.clientHeight * 0.9,
  bottom: pageRatio * 70
})
const isShowBackTop = computed(() => {
  return storeData.isShowBackTop
})
const isImmediateBackTop = computed(() => {
  return storeData.isImmediateBackTop
})
const isPageScroll = ref(false)

onMounted( () => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

// 页面滚动
const handleScroll = () => {
  currentPosition.value = Math.ceil(window.scrollY || document.documentElement?.scrollTop || document.body?.scrollTop || 0)
  isPageScroll.value = true
  clearTimeout(scrollTimer.value)
  scrollTimer.value = setTimeout(() => {
    isPageScroll.value = false
  }, 1000); // 检测滚动停止的时间间隔
}
</script>

<style lang="scss">
.back-top {
  width: 53px;
  height: 53px;
  background: none;
  box-shadow: none;
  right: 10px;
  animation: all 1s infinite;
  &--icon {
    width: 53px;
    height: 53px;
  }
  &.page-scroll {
    right: -26px;
    .back-top--icon {
      opacity: 0.5;
    }
  }
}
</style>